<template>
  <div
    class="employee-inner employee-inner-info"
    :class="{'employee-inner-full' : tabActive}"
  >
    <ListInfo :loadData="loadData" :setup-panel="contractList" @open-detail="openDetail('contract', $event)" @open-modal="openModal($event)" />

    <ListInfo v-if="cheeckRetire" :loadData="loadData" :setup-panel="retireList" @open-modal="openModal($event)" />

    <!-- Employee update -->
    <!-- <div class="update-content" :class="{'update-content-load' : loadData}">
      <div class="content-header">
        <p>Latest Update</p>
      </div>

      <div class="content-subheader">
        <p>{{ thisMonthnow }}</p>
      </div>

      <div class="content-outer">
        <div v-if="latestUpdate && !loadData" class="notif-container">
          <div v-for="data in latestUpdate" :key="data" class="notif-update-content">
            <p>{{ data.title }}</p>
            <p>{{ data.info }}</p>
            <p>{{ formatDate(data.createdat, 'date') }}</p>
          </div>
        </div>

        <div v-if="loadData" class="notif-container">
          <div v-for="data in 5" :key="data" class="notif-update-content"></div>
        </div>

        <div class="buttons-container">
          <div @click="openModal('latestUpdate', true, formatList(latestUpdatefull))" class="button-general button-primary" :class="{'button-frezee' : loadData}">
            <p>See All</p>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
  /* eslint-disable */
  import { defineComponent, ref, reactive, onBeforeMount, onMounted, watch, watchEffect, computed } from "vue"
  import { useRouter, useRoute } from "vue-router"
  import { useI18n } from 'vue-i18n'
  import { useStore } from 'vuex'
  import axios from 'axios'
  import dayjs from 'dayjs'

  import ListInfo from "../EmployeeInfo/ListInfo.vue"

  import DefaultUserImg from '@/assets/general/usericon.png'

  export default {
    components: {
      ListInfo
    },

    props: {
      tabActive: { type: Boolean, default: true },
      loadData: { type: Boolean, default: false },
      expiringContract: { type: Object, default: [] },
      expiredContract: { type: Object, default: [] },
      expiringContractfull: { type: Object, default: [] },
      expiredContractfull: { type: Object, default: [] },
      employeeRetiring: { type: Object, default: [] },
      employeeRetired: { type: Object, default: [] }
    },

    setup(props, { emit }) {
      const { t, locale } = useI18n()
      const router = useRouter()
      const route = useRoute()
      const store = useStore()

      const contractList = ref({})
      const retireList = ref({})
      const cheeckRetire = ref(false)

      const monthsId = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"]
      const monthsEn = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
      const shortMonthsId = ["Jan", "Feb", "Mar", "Apr", "Mei", "Jun", "Jul", "Agu", "Sep", "Okt", "Nov", "Des"]
      const shortMonthsEn = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Agu", "Sep", "Oct", "Nov", "Dec"]
      const daysId = ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"]
      const daysEn = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
      const shortDaysId = ["Min", "Sen", "Sel", "Rab", "Kam", "Jum", "Sab"]
      const shortDaysEn = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]
      function formatDate(date, type) {
        const day = new Date(date).getDate()
        const month = new Date(date).getMonth()
        const year = new Date(date).getFullYear()
        const dayOfWeek = new Date(date).getDay()

        const months = locale.value == 'id' ? monthsId : monthsEn
        const monthsShort = locale.value == 'id' ? shortMonthsId : shortMonthsEn
        const days = locale.value == 'id' ? daysId : daysEn
        const daysShort = locale.value == 'id' ? shortDaysId : shortDaysEn

        if(type == 'dateTime') {
            return `${days[dayOfWeek]}, ${day} ${months[month]} ${year}`
        }
        else if(type == 'date') {
            return `${day} ${months[month]} ${year}`
        }
        else if(type == 'day') {
            return `${day}`
        }
        else if(type == 'shortDay') {
            return `${daysShort[dayOfWeek]}`
        }
      }


      const formatSortMonth = (data) => {
        const sortedMonths = data.sort((a, b) => b.month_number - a.month_number)
        return sortedMonths
      }


      function formatList(data) {
        const monthNames = [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ]
        const groupedData = {}

        data.forEach(item => {
          const dateObj = new Date(item.createdat)
          const year = dateObj.getFullYear().toString()
          const monthIndex = dateObj.getMonth()
          const monthName = monthNames[monthIndex]

          if (!groupedData[year]) {
            groupedData[year] = {}
          }


          if (!groupedData[year][monthName]) {
            groupedData[year][monthName] = {
              data: [],
              index: monthIndex
            }
          }

          groupedData[year][monthName].data.push(item)
        })

        const result = Object.entries(groupedData)
        .sort((a, b) => b[0] - a[0])
        .map(([year, months]) => {
          const sortedMonths = Object.entries(months)
            .sort((a, b) => b[1].index - a[1].index)
            .map(([month_name, { data }]) => ({
              month_name,
              data
            }))

          return {
            year,
            month: sortedMonths
          }
        })

        return result
      }


      const openDetail = (type, data) => {
        emit("open-detail", {type, data})
      }


      const openModal = (data) => {
        emit("open-modal", data)
      }


      onBeforeMount(() => {

      })

      onMounted(() => {

      })

      watchEffect(() => {
        if(
          props.expiringContract ||
          props.expiredContract ||
          props.expiringContractfull ||
          props.expiredContractfull
        ) {
          contractList.value = {
            id: "contract_list_container",
            title: "Contract",
            month: null,
            child: [
              {
                id: "expiringContract",
                title: "Is Expiring",
                container_color: 'yellow',
                dataShow: props.expiringContract,
                dataFull: props.expiringContractfull
              },
              {
                id: "expiredContract",
                title: "Is Expired",
                container_color: 'red',
                dataShow: props.expiredContract,
                dataFull: props.expiredContractfull
              },
            ]
          }
        }

        if(
          props.employeeRetiring ||
          props.employeeRetired
        ) {
          retireList.value = {
            id: "retire_list_container",
            title: "Retire Employee",
            month: "disable",
            no_data: "No Data!",
            child: [
              {
                id: "retiring_employee",
                title: "Retiring",
                container_color: 'yellow',
                dataShow: props.employeeRetiring,
                dataCondition: 'nextYear',
                dataFull: []
              },
              {
                id: "retired_employee",
                title: "Retired",
                container_color: 'red',
                dataShow: props.employeeRetired,
                dataFull: []
              },
            ]
          }
        }

        // console.log("cek data retiring", props.employeeRetiring)
        // console.log("cek data retired", props.employeeRetired)


        if((props.employeeRetiring.length != 0) || (props.employeeRetired.length != 0)) {
          // console.log("cek retire", props.employeeRetiring,  props.employeeRetired)
          cheeckRetire.value = true
        }
      })

      return {
        DefaultUserImg,
        formatDate,
        formatSortMonth,
        formatList,
        openModal,
        contractList,
        retireList,
        cheeckRetire,
        openDetail
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>
